import palette from '../palette';

export default {
  root: {
    '&$selected': {
      backgroundColor: palette.colors.lightPrimaryBlue,
    },
    '&$hover': {
      '&:hover': {
        backgroundColor: palette.grey['50'],
      },
    },
  },
};
